
import { Component, Vue } from 'vue-property-decorator';
import SysNotice from "@/components/SysNotice/Index.vue";
import {moduleApi, ssoApi} from "@/api/organization";
import ChangeUserPwd from "@/components/sys/ChangeUserPwd.vue";
import Caozuoshouce from "@/components/Caozuoshouce.vue";
import {isPlaced, ModuleTile, normalizeResources} from "@/js/moduleLayout";

type HomeModule = ModuleTile & {url: string};

@Component({
    components: {ChangeUserPwd, SysNotice, Caozuoshouce}
})
export default class Home extends Vue {
    title = "主页内容";
    list: HomeModule[] = [];
    loading = false;
    helpVisible = false;
    // 按原文件名顺序展示压缩图片，仅作静态展示。
    homeImages = [
        {name: '登录验证1', src: require('../../../static/image/homeGallery/登录验证1.jpg')},
        {name: '登录验证2', src: require('../../../static/image/homeGallery/登录验证2.jpg')},
        {name: '登录验证3', src: require('../../../static/image/homeGallery/登录验证3.jpg')},
        {name: '登录验证4', src: require('../../../static/image/homeGallery/登录验证4.jpg')},
        {name: '登录验证5', src: require('../../../static/image/homeGallery/登录验证5.jpg')}
    ];
    helpActions = [
        {name: '操作视频', icon: 'el-icon-video-camera', method: 'openShiPin'},
        {name: '操作手册', icon: 'el-icon-reading', method: 'openShouCe'},
        {name: '常见问题', icon: 'el-icon-question', method: 'downloadChangJianWenTi'},
        {name: '智能问答', icon: 'el-icon-chat-line-square', method: 'toZhiNengWenDa'}
    ];
    changeUserPwdDialog = {
      visible: false,
      loginName: ''
    };

    /** 进入首页时检查密码有效期并读取已保存的模块布局。 */
    created() {
        this.isExpiredPwd();
        this.getList();
    }
    /** 复用平台现有图标文件，不生成内嵌图片。 */
    returnImageUrl(path: string){
        let imageUrl = null;
        try {
            imageUrl = require('../../../static/image/indexPage/' + path); // 尝试加载图片
        } catch (error) {
            console.error('Image not found:', error);
        }
        return imageUrl;
    }
    /** 按资源接口返回的坐标展示已放置模块，保留原始跳转地址及提示描述。 */
    async getList() {
        this.loading = true;
        try {
            const r = await moduleApi.list();
            if (r.data.result !== 0) {
                this.$message.error(r.data.message || '资源加载失败');
                return;
            }
            this.list = normalizeResources(r.data.data || []).filter(isPlaced).map(item => {
                const url = item.des || '';
                const des = url.indexOf('http') !== -1
                    ? (item.name === '备案检定' ? '计量检定业务管理系统' : item.name) : url;
                return {...item, url, des};
            });
        } catch (error) {
            this.$message.error('资源加载失败，请刷新后重试');
        } finally {
            this.loading = false;
        }
    }
    /** 将零起始坐标和模块宽高映射到九列三行栅格。 */
    moduleStyle(item: HomeModule) {
        return {
            gridColumn: (item.layoutX + 1) + ' / span ' + item.layoutW,
            gridRow: (item.layoutY + 1) + ' / span ' + item.layoutH
        };
    }
    /** 帮助信息单独弹窗，其余模块沿用原有权限提示和跳转判断。 */
    openModule(item: HomeModule) {
        if (item.name === '帮助信息') {
            this.helpVisible = true;
            return;
        }
        this.toPage(item);
    }
    /** 复用原有帮助组件的资料列表及下载、问答地址。 */
    openHelpResource(method: string) {
        if (!this.helpActions.some(action => action.method === method)) return;
        const resources = this.$refs.helpResources as Vue & {[key: string]: any};
        if (resources && typeof resources[method] === 'function') resources[method]();
    }
    /** 保留首次登录时的密码过期检查。 */
    isExpiredPwd(){
        // 检查 Session Storage 中是否已经验证过密码过期
        const hasChecked = sessionStorage.getItem('hasCheckedPasswordExpiry');
        
        if (hasChecked == null || hasChecked === '0') {
            ssoApi.isExpiredPwd().then((r: any) => {
              if(r.data.result === 0 && r.data.data.expired){
                const { loginName } = r.data.data;
                this.changeUserPwdDialog.visible = true;
                this.changeUserPwdDialog.loginName = loginName;
              }
              sessionStorage.setItem('hasCheckedPasswordExpiry', "1");
            });
        }
    }
    /** 沿用模块的身份校验、业务提示和内外部跳转规则。 */
    toPage(item: any){
        const authedUser = this.$store.state.AuthedUser;
      const organizationTypes = [];
      if(authedUser.organizationType){
        organizationTypes.push(...authedUser.organizationType.split(','));
      }
        if(item.des == "开发中"){
            this.$alert('您没有权限访问此模块', '提示', {
                confirmButtonText: '确定'
            });
            return;
        }else if(item.name == '备案检定' && [0, 1].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理计量器具备案、检定等业务，请使用个人账户重新登陆。");
            return;
        }else if(item.name == '备案检定' && [3].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你当前的身份是注册用户，不能办理计量器具备案、检定等业务，请先绑定单位后重新登陆再试。");
            return;
        }else if(item.name == '计量考评员' && [0, 1].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理计量考评员相关业务，请使用个人账户重新登陆。");
            return;
        }else if(item.name == '计量考评员' && [3].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你当前的身份是注册用户，不能办理计量考评员相关业务，请先绑定单位后重新登陆再试。");
            return;
        }else if(item.name == '注册计量师' && [0, 1].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理注册计量师相关业务，请使用个人账户重新登陆。");
            return;
        }else if(item.name == '注册计量师' && [3].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你当前的身份是注册用户，不能办理注册计量师相关业务，请先绑定单位后重新登陆再试。");
            return;
        }else if(item.name == '从业人员' && [0, 1].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理从业人员相关业务，请使用个人账户重新登陆。");
            return;
        }else if(item.name == '从业人员' && [3].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你当前的身份是注册用户，不能办理从业人员相关业务，请先绑定单位后重新登陆再试。");
            return;
        }else if(item.name == '从业人员'){
          if(organizationTypes.includes("0001") || organizationTypes.includes("0003") || organizationTypes.includes("0006") ||organizationTypes.includes("0008")){
            window.location.href = "https://im.hebjlzy.com/#/?redirect=/congyerenyuan/self-desc/index&relogin=true";
          }else{
            window.location.href = "https://im.hebjlzy.com/#/?redirect=/congyerenyuan/person-info/index&relogin=true";
          }
        }else if(item.name == '监督管理' && [3].indexOf(authedUser.type) > -1){
          this.$message.warning("对不起！你当前的身份是注册用户，不能办理监督管理相关业务，请先绑定单位后重新登陆再试。");
          return;
        }else if(item.name == '监督管理' && [0, 1].indexOf(authedUser.type) > -1){
          this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理监督管理相关业务，请使用个人账户重新登陆。");
          return;
        }else if(item.name == '评价和确认' && [3].indexOf(authedUser.type) > -1){
          this.$message.warning("对不起！你当前的身份是注册用户，不能办理评价和确认相关业务，请先绑定单位后重新登陆再试。");
          return;
        }else if(item.name == '评价和确认' && [0, 1].indexOf(authedUser.type) > -1){
          this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理评价和确认相关业务，请使用个人账户重新登陆。");
          return;
        }else if(item.name == '监督管理' && (!organizationTypes.includes('0001') && !organizationTypes.includes('0002') && !organizationTypes.includes('0003') && !organizationTypes.includes('0006') && !organizationTypes.includes('0008'))){
          this.$message.warning("对不起！您没有权限办理监督管理相关业务。");
          return;
        }else if(item.url.startsWith("http")){
            //如果描述是http开头，直接跳转
            window.location.href = item.url;
            return;
        }
        this.$router.push('/home/' + item.id);
        // const routeData = this.$router.resolve('/home/' + item.id);
        // window.open(routeData.href, '_blank');
    }
}
